import script from "./AgentChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentChat.vue?vue&type=script&setup=true&lang=js"

import "./AgentChat.vue?vue&type=style&index=0&id=22987b4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22987b4c"]])

export default __exports__